(()=>{
const root=document.getElementById('uv-pilot');if(!root)return;document.body.classList.add('uv-printed-template');const media=document.querySelector('.product__media-wrapper'),info=document.querySelector('.product__info-container');if(media&&info){for(const child of media.children)child.hidden=true;media.appendChild(root.querySelector('.preview-panel'));const qty=info.querySelector('.product-form__quantity');info.insertBefore(root.querySelector('.controls'),qty);info.insertBefore(root.querySelector('.lab-review'),qty);}root.querySelector('.workspace').remove();
// Pure pixel operations. No DOM, network, Shopify or production RIP side effects.
const ENGINE_VERSION = 'uv-pilot-1';
function detectEdgeColor(source, width, height) {
  const fallback = { color: '#ffffff', detected: false, confidence: 0 };
  if (width < 2 || height < 2 || source.length !== width * height * 4) return fallback;
  const points = [], stride = Math.max(1, Math.floor(Math.max(width, height) / 256));
  for(let x=0;x<width;x+=stride){points.push([x,0,0],[x,height-1,1]);}
  for(let y=0;y<height;y+=stride){points.push([0,y,2],[width-1,y,3]);}
  const samples=points.map(([x,y,side])=>({rgb:[...source.slice((y*width+x)*4,(y*width+x)*4+3)],alpha:source[(y*width+x)*4+3],side}));
  const opaque=samples.filter(s=>s.alpha>=250);
  // Transparent borders do not reveal a removable background color. Never sample
  // invisible RGB bytes or hunt inward until a logo's foreground is mistaken for it.
  if(opaque.length<samples.length*.6)return fallback;
  const bins=new Map();for(const s of opaque){const key=s.rgb.map(v=>Math.floor(v/16)).join(',');const bin=bins.get(key)||[];bin.push(s);bins.set(key,bin);}
  const dominant=[...bins.values()].sort((a,b)=>b.length-a.length)[0];
  const seed=[0,1,2].map(i=>dominant.reduce((sum,s)=>sum+s.rgb[i],0)/dominant.length);
  const matches=opaque.filter(s=>Math.max(...s.rgb.map((v,i)=>Math.abs(v-seed[i])))<=24);
  const confidence=matches.length/opaque.length;
  if(confidence<.75||new Set(matches.map(s=>s.side)).size<3)return {...fallback,confidence};
  const rgb=[0,1,2].map(i=>Math.round(matches.reduce((sum,s)=>sum+s.rgb[i],0)/matches.length));
  return {color:'#'+rgb.map(v=>v.toString(16).padStart(2,'0')).join(''),detected:true,confidence};
}
function removeBackground(source, width, height, options = {}) {
  if (source.length !== width * height * 4) throw Error('Pixel dimensions do not match');
  const out = new Uint8ClampedArray(source);
  if (!options.enabled) return out;
  const rgb = options.color || [255, 255, 255];
  const tolerance = Math.max(0, Math.min(100, Number(options.tolerance) || 0)) * 2.55;
  const feather = Math.max(0, Math.min(30, Number(options.feather) || 0)) * 2.55;
  const count = width * height, distances = new Float32Array(count), eligible = new Uint8Array(count);
  for (let p = 0; p < count; p++) {
    const i = p * 4;
    // Maximum channel distance is deliberately simple and reproducible, not an AI segmentation claim.
    distances[p] = Math.max(Math.abs(source[i] - rgb[0]), Math.abs(source[i + 1] - rgb[1]), Math.abs(source[i + 2] - rgb[2]));
    eligible[p] = source[i + 3] === 0 || distances[p] <= tolerance + feather ? 1 : 0;
  }
  let selected;
  if (options.scope === 'all') selected = eligible;
  else {
    selected = new Uint8Array(count);
    const queue = new Uint32Array(count); let tail = 0;
    const add = p => { if (eligible[p] && !selected[p]) { selected[p] = 1; queue[tail++] = p; } };
    for (let x = 0; x < width; x++) { add(x); add((height - 1) * width + x); }
    for (let y = 0; y < height; y++) { add(y * width); add(y * width + width - 1); }
    for (let head = 0; head < tail; head++) {
      const p = queue[head], x = p % width, y = Math.floor(p / width);
      if (x) add(p - 1); if (x < width - 1) add(p + 1);
      if (y) add(p - width); if (y < height - 1) add(p + width);
    }
  }
  for (let p = 0; p < count; p++) {
    if (!selected[p]) continue;
    const a = feather ? Math.max(0, Math.min(1, (distances[p] - tolerance) / feather)) : 0;
    out[p * 4 + 3] = Math.round(source[p * 4 + 3] * a);
    // RGB bytes remain unchanged; no automatic recoloring/unmatting of logo edges.
  }
  return out;
}
// Quarter turns clockwise, pixel for pixel: no resampling, so edges stay exactly as uploaded.
function rotateQuarter(source, width, height, turns) {
  turns = ((turns % 4) + 4) % 4;
  const w = turns % 2 ? height : width, h = turns % 2 ? width : height;
  if (!turns) return { data: source, width: w, height: h };
  const out = new Uint8ClampedArray(source.length);
  for (let sy = 0; sy < height; sy++) for (let sx = 0; sx < width; sx++) {
    const dx = turns === 1 ? height - 1 - sy : turns === 2 ? width - 1 - sx : sy;
    const dy = turns === 1 ? sx : turns === 2 ? height - 1 - sy : width - 1 - sx;
    const i = (sy * width + sx) * 4, o = (dy * w + dx) * 4;
    out[o] = source[i]; out[o + 1] = source[i + 1]; out[o + 2] = source[i + 2]; out[o + 3] = source[i + 3];
  }
  return { data: out, width: w, height: h };
}
function whiteCoverage(rgba) {
  const out = new Uint8ClampedArray(rgba.length);
  for (let i = 0; i < rgba.length; i += 4) {
    out[i] = out[i + 1] = out[i + 2] = 255; out[i + 3] = rgba[i + 3];
  }
  return out;
}
function opaqueCoverage(rgba) {
  const out = new Uint8ClampedArray(rgba.length);
  for (let i = 0; i < rgba.length; i += 4) {
    out[i] = out[i + 1] = out[i + 2] = rgba[i + 3]; out[i + 3] = 255;
  }
  return out;
}
function hexRgb(hex) {
  if (!/^#[a-f\d]{6}$/i.test(hex)) throw Error('Invalid color');
  return [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16));
}
function fit(sourceWidth, sourceHeight, width, height) {
  if (![sourceWidth, sourceHeight, width, height].every(v => v > 0)) throw Error('Invalid dimensions');
  const scale = Math.min(width / sourceWidth, height / sourceHeight);
  return { width: sourceWidth * scale, height: sourceHeight * scale };
}
function transformBounds(layer, width, height) {
  const angle = layer.rotation * Math.PI / 180, c = Math.cos(angle), s = Math.sin(angle);
  const hw = width * layer.scale / 2, hh = height * layer.scale / 2;
  return [[-hw,-hh],[hw,-hh],[hw,hh],[-hw,hh]].map(([x,y]) => [layer.x + x*c-y*s,layer.y+x*s+y*c]);
}
function crc32(bytes) {
  let crc = -1;
  for (const b of bytes) { crc ^= b; for (let j = 0; j < 8; j++) crc = (crc >>> 1) ^ (0xedb88320 & -(crc & 1)); }
  return (crc ^ -1) >>> 0;
}
// Store-only ZIP: portable review package, no dependency or external upload required.
function zipStore(entries) {
  const enc = new TextEncoder(), chunks = [], directory = []; let offset = 0;
  for (const { name, bytes } of entries) {
    if (!/^[a-zA-Z0-9_.\/-]+$/.test(name) || name.includes('..')) throw Error('Unsafe archive name');
    const n = enc.encode(name), checksum = crc32(bytes);
    const local = new Uint8Array(30 + n.length), l = new DataView(local.buffer);
    l.setUint32(0, 0x04034b50, true); l.setUint16(4, 20, true);
    l.setUint32(14, checksum, true); l.setUint32(18, bytes.length, true); l.setUint32(22, bytes.length, true);
    l.setUint16(26, n.length, true); local.set(n, 30); chunks.push(local, bytes);
    const central = new Uint8Array(46 + n.length), d = new DataView(central.buffer);
    d.setUint32(0, 0x02014b50, true); d.setUint16(4, 20, true); d.setUint16(6, 20, true);
    d.setUint32(16, checksum, true); d.setUint32(20, bytes.length, true); d.setUint32(24, bytes.length, true);
    d.setUint16(28, n.length, true); d.setUint32(42, offset, true); central.set(n, 46);
    directory.push(central); offset += local.length + bytes.length;
  }
  const end = new Uint8Array(22), e = new DataView(end.buffer), size = directory.reduce((s,d)=>s+d.length,0);
  e.setUint32(0, 0x06054b50, true); e.setUint16(8, entries.length, true); e.setUint16(10, entries.length, true);
  e.setUint32(12, size, true); e.setUint32(16, offset, true);
  const result = new Uint8Array(offset + size + 22); let at = 0;
  for (const chunk of [...chunks, ...directory, end]) { result.set(chunk, at); at += chunk.length; }
  return result;
}
const $ = id => document.getElementById('uv-'+id);
const PROFILE=JSON.parse(document.getElementById('uv-render-config')?.textContent||'{}');
const stageHeight=PROFILE.stageHeight||360,stageTop=PROFILE.stageTop??120;
const area = PROFILE.area || { x: 46.5, y: 243.5, width: 507, height: 113 };
const config = {
  schemaVersion: 1, productId: root.closest('[data-product-id]')?.dataset.productId || String(JSON.parse(document.getElementById('uv-commerce-config').textContent).productId), sku: '1840-8000-Custom', method: 'uv', shape: PROFILE.shape || 'rectangle',
  geometrySource: 'Existing FPD 600px stage; centered for pilot; physical size UNVERIFIED',
  printWidthMm: null, printHeightMm: null, side: PROFILE.side || 'unverified', mirrored: false,
  geometryVerified: false, productionReady: false, area,
  whiteMode: 'under-artwork', whiteDensity: 'requires-production-validation', chokeMm: null,
  printer: 'Roland LEF2-300', sequence: ['white', 'color'], topcoat: false
};
const CFG=JSON.parse(document.getElementById('uv-commerce-config').textContent);const controlsPanel=document.querySelector('.uv-pilot.controls');root.classList.add('cpd--mounted');
let processedBounds = null, removalSupported = true;
let original = null, processed = null, sourceFile = null, originalBytes = null;
let originalSize = null, view = 'product', blank = new Image(), x = 0, y = 0, scale = 1, rotation = 0;
let loadVersion = 0, loading = false, renderRequest = 0;
const surface = (w,h) => { const c=document.createElement('canvas'); c.width=w;c.height=h;return c; };
const preview = $('preview'), ctx = preview.getContext('2d');
preview.height=stageHeight*2;preview.style.aspectRatio='600 / '+stageHeight;
let activeProfile=null,activeVariant=null,productMask=null,maskReady=true,fitRegion=null,pendingMaskFit=false,artworkCrossesCutout=false;
function maskFitRegion(){
 const w=Math.ceil(area.width),h=Math.ceil(area.height),s=surface(w,h),c=s.getContext('2d');
 c.translate(-area.x,-area.y);drawProfileImage(c,productMask,activeProfile.mask.body,activeProfile);
 const data=c.getImageData(0,0,w,h).data,heights=new Array(w).fill(0);let best={x:0,y:0,width:0,height:0};
 for(let yy=0;yy<h;yy++){
  for(let xx=0;xx<w;xx++)heights[xx]=data[(yy*w+xx)*4+3]<8?heights[xx]+1:0;
  const stack=[];
  for(let xx=0;xx<=w;xx++){const height=xx===w?0:heights[xx];let left=xx;while(stack.length&&stack[stack.length-1].height>height){const p=stack.pop(),width=xx-p.left;if(width*p.height>best.width*best.height)best={x:p.left,y:yy-p.height+1,width,height:p.height};left=p.left;}stack.push({left,height});}
 }
 return best.width&&best.height?best:null;
}
function drawProfileImage(c,image,body,p){
 c.save();c.translate(300,300);c.scale(p.zoom,p.zoom);c.translate(body.x-p.center.x,body.y-p.center.y);c.rotate(body.angle*Math.PI/180);c.scale(body.sx,body.sy);c.drawImage(image,-image.naturalWidth/2,-image.naturalHeight/2);c.restore();
}
function syncRenderVariant(){
 if(!PROFILE.variants)return;
 const id=info?.querySelector('form[action*="/cart/add"] [name="id"]')?.value || new URL(location.href).searchParams.get('variant') || Object.keys(PROFILE.variants)[0];
 if(id===activeVariant)return;
 const next=PROFILE.variants[id];if(!next)return;
 activeVariant=id;activeProfile=next;config.sku=next.sku;config.variantId=id;config.geometrySource=PROFILE.geometrySource||'Straight-on product rendering with centered oval; physical print dimensions pending confirmation';
 if(next.area)Object.assign(area,next.area);
 config.printMask=next.mask||null;
 productMask=null;fitRegion=null;maskReady=!next.mask;artworkCrossesCutout=false;
 if(next.mask){
  const im=new Image();im.crossOrigin='anonymous';productMask=im;
  im.onload=()=>{if(productMask!==im)return;maskReady=true;fitRegion=maskFitRegion();if(pendingMaskFit){pendingMaskFit=false;fitVisibleArtwork();}else render();};
  im.onerror=()=>{if(productMask!==im)return;$('status').textContent='The print area could not load. Refresh the page before adding your design.';};
  im.src=next.mask.image;
 }
 blank.src=next.image;render();
}
if(PROFILE.variants){document.addEventListener('change',()=>setTimeout(syncRenderVariant,0));new MutationObserver(syncRenderVariant).observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});}
blank.crossOrigin = 'anonymous'; blank.onload = render; blank.src = root.dataset.blank;
blank.onerror = () => { $('status').textContent='Product image could not load. Artwork inspection remains available.'; };
function options() { return {enabled:removalSupported&&$('remove').checked,color:[255,255,255],tolerance:Math.min(20,+$('tolerance').value),feather:0,scope:'all'}; }
function controls() {
  $('removalOptions').hidden = !$('remove').checked;
  controlsPanel.classList.toggle('has-artwork',!!original);
  $('fileSummary').hidden=!original;
  $('uploadLabel').textContent=original?'Replace your design':'Upload your logo';
  $('toleranceValue').value = $('tolerance').value;
  $('backgroundFields').hidden=!original; $('position').hidden=!original;
  $('zoomValue').value = Math.round(scale*100)+'%'; $('zoom').value = scale*100;
  $('removalNote').textContent = 'White details inside the logo are removed too. Check your preview.';
  $('backgroundHelp').hidden=removalSupported;
  for(const id of ['remove','zoom','fit','rotate','downloadArt','downloadWhite','downloadProof','downloadPackage']) $(id).disabled=!original||loading;
  $('remove').disabled=!original||loading||!removalSupported;
}
function processArtwork() {
  if (!original) return;
  const turned=rotateQuarter(removeBackground(original.data, original.width, original.height, options()),original.width,original.height,rotation/90);
  const c=surface(turned.width,turned.height), data=c.getContext('2d').createImageData(c.width,c.height);
  data.data.set(turned.data);
  c.getContext('2d').putImageData(data,0,0); processed=c; processedBounds=visibleBounds(data.data,c.width,c.height); controls(); render();
}
function fitBox() { return processed ? fit(processed.width,processed.height,area.width*.90,area.height*.90) : {width:0,height:0}; }
// Bounds measure visible pixels only; the source and output canvas remain intact.
function visibleBounds(data,width,height) {
  let left=width,top=height,right=-1,bottom=-1;
  for(let py=0;py<height;py++)for(let px=0;px<width;px++)if(data[(py*width+px)*4+3]>0){left=Math.min(left,px);top=Math.min(top,py);right=Math.max(right,px);bottom=Math.max(bottom,py);}
  return right<0?null:{left,top,width:right-left+1,height:bottom-top+1};
}
function artworkBounds(){return processedBounds;}
function fitVisibleArtwork(){
  if(!processed)return;
  if(!maskReady){pendingMaskFit=true;return;}
  const bounds=artworkBounds(),f=fitBox();
  if(!bounds){$('status').textContent='No visible artwork remains. Restore the background or adjust removal.';return;}
  const unit=f.width/processed.width;
  const target=fitRegion||{x:0,y:0,width:area.width,height:area.height};
  scale=PROFILE.shape==='oval' ? .9/Math.hypot(bounds.width*unit/area.width,bounds.height*unit/area.height) : Math.min(target.width*.9/(bounds.width*unit),target.height*.9/(bounds.height*unit));
  $('zoom').max=String(Math.max(1000,Math.ceil(scale*100/100)*100));
  x=target.x+target.width/2-area.width/2-(bounds.left+bounds.width/2-processed.width/2)*unit*scale;
  y=target.y+target.height/2-area.height/2-(bounds.top+bounds.height/2-processed.height/2)*unit*scale;
  controls();render();
}
function setZoom(next,anchorX=0,anchorY=0){
  if(!processed||loading)return;
  next=Math.max(.1,Math.min(+$('zoom').max/100,next));
  const ratio=next/scale;x=anchorX+(x-anchorX)*ratio;y=anchorY+(y-anchorY)*ratio;scale=next;controls();render();
}
function renderLayers(multiplier=4) {
  const color=surface(Math.round(area.width*multiplier),Math.round(area.height*multiplier)), c=color.getContext('2d');

  if(processed) {
    const f=fitBox(), w=f.width*scale*multiplier, h=f.height*scale*multiplier;
    c.drawImage(processed,(area.width/2+x)*multiplier-w/2,(area.height/2+y)*multiplier-h/2,w,h);
  }
  if(PROFILE.shape==='oval'){c.globalCompositeOperation='destination-in';c.beginPath();c.ellipse(color.width/2,color.height/2,color.width/2,color.height/2,0,0,Math.PI*2);c.fill();c.globalCompositeOperation='source-over';}
  // Apply the same cutout mask before generating either the preview or white ink.
  // Fail closed while the variant's mask is loading; never export an unmasked logo.
  let beforeMask=null;
  if(activeProfile?.mask){
    if(!maskReady)c.clearRect(0,0,color.width,color.height);
    else {beforeMask=c.getImageData(0,0,color.width,color.height).data;c.save();c.scale(multiplier,multiplier);c.translate(-area.x,-area.y);c.globalCompositeOperation='destination-out';drawProfileImage(c,productMask,activeProfile.mask.body,activeProfile);c.restore();}
  }
  const data=c.getImageData(0,0,color.width,color.height);
  artworkCrossesCutout=false;
  if(beforeMask){let removed=0;for(let i=3;i<beforeMask.length;i+=4)if(beforeMask[i]>32&&data.data[i]<beforeMask[i]-32)removed++;artworkCrossesCutout=removed>4*multiplier*multiplier;}
  const white=surface(color.width,color.height), wc=white.getContext('2d');
  const wd=wc.createImageData(color.width,color.height);wd.data.set(whiteCoverage(data.data));wc.putImageData(wd,0,0);
  const coverage=surface(color.width,color.height), mc=coverage.getContext('2d');
  const md=mc.createImageData(color.width,color.height);md.data.set(opaqueCoverage(data.data));mc.putImageData(md,0,0);
  return {color,white,coverage,data};
}
function checker(c,left,top,w,h) {
  c.save();c.beginPath();c.rect(left,top,w,h);c.clip();
  for(let yy=0;yy<h;yy+=12)for(let xx=0;xx<w;xx+=12){c.fillStyle=((xx/12+yy/12)%2)?'#d5dbdc':'#f5f7f7';c.fillRect(left+xx,top+yy,12,12);}c.restore();
}
function paint(c, width, height, guides=true) {
  c.save();c.scale(width/600,height/stageHeight);c.translate(0,-stageTop);c.clearRect(0,stageTop,600,stageHeight);c.fillStyle='#fff';c.fillRect(0,stageTop,600,stageHeight);
  const bg=$('backdrop').value;
  if(view==='product' && bg==='photo' && blank.complete && blank.naturalWidth) {
    // Original FPD base: center (300.09091,300), scale .498751; shift to center print region.
    if(activeProfile){const p=activeProfile,b=p.body;c.save();c.translate(300,300);c.scale(p.zoom,p.zoom);c.translate(b.x-p.center.x,b.y-p.center.y);c.rotate(b.angle*Math.PI/180);c.scale(b.sx,b.sy);c.drawImage(blank,-blank.naturalWidth/2,-blank.naturalHeight/2);c.restore();}else c.drawImage(blank,300.09091+1.5-blank.naturalWidth*.4987510407993339/2,300-18.5-blank.naturalHeight*.4987510407993339/2,blank.naturalWidth*.4987510407993339,blank.naturalHeight*.4987510407993339);
  } else {
    if(bg==='checker'||view!=='product')checker(c,area.x,area.y,area.width,area.height);
    else {c.fillStyle=bg==='photo'?'#dce0da':bg;c.fillRect(area.x,area.y,area.width,area.height);}
  }
  if(processed) {
    const layers=renderLayers(2);
    // Artwork on screen is already the intended visible color. Do not alpha-compose
    // the white mask a second time: that would exaggerate partial-alpha coverage.
    c.drawImage(view==='white'?layers.white:layers.color,area.x,area.y,area.width,area.height);
    } else { c.fillStyle='#677362';c.font='15px Arial';c.textAlign='center';c.fillText('Upload your logo',area.x+area.width/2,area.y+area.height/2+3,Math.max(20,area.width-16)); }
    if(view==='product' && bg==='photo' && activeProfile?.mask && activeProfile.mask.overlay!==false && maskReady)drawProfileImage(c,productMask,activeProfile.mask.body,activeProfile);
  if(guides){c.setLineDash([5,5]);c.strokeStyle='#6b963e';c.lineWidth=1;if(PROFILE.shape==='oval'){c.beginPath();c.ellipse(300,300,area.width/2,area.height/2,0,0,Math.PI*2);c.stroke();}else c.strokeRect(area.x,area.y,area.width,area.height);}
  c.restore();
}
function updateEditHint(){$('editHint').hidden=!processed || $('skip').checked || !$('photo').hidden;}
function render() {
  paint(ctx,preview.width,preview.height);
  if(processed) {
    const f=fitBox(),b=artworkBounds(),unit=f.width/processed.width*scale;
    const cropped=b && (x+(b.left-processed.width/2)*unit < -area.width/2-.01 || x+(b.left+b.width-processed.width/2)*unit > area.width/2+.01 || y+(b.top-processed.height/2)*unit < -area.height/2-.01 || y+(b.top+b.height-processed.height/2)*unit > area.height/2+.01);
    $('editHint').classList.toggle('is-warning',!!cropped||artworkCrossesCutout);
    $('editMessage').textContent=cropped?'Part of your design is outside the print area.':artworkCrossesCutout?'Part of your design overlaps an unprinted opening.':'Drag to position · Scroll to zoom';
    $('overlayFit').hidden=!cropped&&!artworkCrossesCutout;
    $('status').textContent = (originalSize?.downsampled?'This large file uses a reduced preview. The untouched original is retained for the art team.':'');
  }
  updateEditHint();
}
function scheduleProcess(){cancelAnimationFrame(renderRequest);renderRequest=requestAnimationFrame(processArtwork);}
function resetSettings(){x=0;y=0;scale=1;rotation=0;$('remove').checked=false;$('tolerance').value='8';removalSupported=true;if(original){const detected=detectEdgeColor(original.data,original.width,original.height);removalSupported=!detected.detected||hexRgb(detected.color).every(v=>v>=235);}}
async function loadFile(file) {
  if(!file || file.size>20*1024*1024){$('status').textContent='Choose an image smaller than 20 MB.';return;}
  if(!['image/png','image/jpeg','image/webp'].includes(file.type)){ $('status').textContent='Preview a PNG, JPG or WEBP here. For SVG, PDF, AI or EPS, choose Skip the designer and send your file after checkout.';return; }
  const version=++loadVersion;
  loading=true;controls();$('filename').textContent='Loading '+file.name+'…';
  try {
    const bitmap=await createImageBitmap(file), bytes=new Uint8Array(await file.arrayBuffer());
    if(version!==loadVersion){bitmap.close();return;}
    const ratio=Math.min(1,2048/Math.max(bitmap.width,bitmap.height));
    const c=surface(Math.max(1,Math.round(bitmap.width*ratio)),Math.max(1,Math.round(bitmap.height*ratio)));
    c.getContext('2d').drawImage(bitmap,0,0,c.width,c.height);
    originalSize={width:bitmap.width,height:bitmap.height,downsampled:ratio<1};bitmap.close();
    original=c.getContext('2d').getImageData(0,0,c.width,c.height);sourceFile=file;originalBytes=bytes;resetSettings();$('skip').checked=false;showDesign();
    $('filename').textContent=file.name;$('fileThumb').src=c.toDataURL('image/png');loading=false;processArtwork();fitVisibleArtwork();
  } catch(error) {if(version===loadVersion){$('filename').textContent='Could not read that image. Please choose another file.';loading=false;controls();}}
}
$('upload').addEventListener('change',e=>loadFile(e.target.files[0]));
$('clear').onclick=()=>{
  ++loadVersion;cancelAnimationFrame(renderRequest);loading=false;
  original=null;processed=null;processedBounds=null;sourceFile=null;originalBytes=null;originalSize=null;
  ready=false;resetSettings();view='product';$('backdrop').value='photo';$('zoom').max='1000';
  $('upload').value='';$('filename').textContent='';$('fileThumb').removeAttribute('src');
  $('status').textContent='Design cleared.';$('exportStatus').textContent='';
  $('skip').checked=false;orderError('');
  for(const name of ['_Artwork','_Proof','_WhiteCoverage','_Preview','_Design','Artwork']){
    const field=form?.elements.namedItem('properties['+name+']');
    if(field){field.value='';if(field.type==='file')field.disabled=true;}
  }
  showDesign();controls();render();$('upload').focus();
};
const uploadZone=$('upload').closest('.upload');
for(const event of ['dragenter','dragover'])uploadZone.addEventListener(event,e=>{e.preventDefault();uploadZone.classList.add('is-over');});
for(const event of ['dragleave','drop'])uploadZone.addEventListener(event,e=>{e.preventDefault();uploadZone.classList.remove('is-over');});
uploadZone.addEventListener('drop',e=>loadFile(e.dataTransfer.files[0]));
$('tolerance').addEventListener('input',scheduleProcess);
$('remove').addEventListener('change',()=>{cancelAnimationFrame(renderRequest);processArtwork();fitVisibleArtwork();});

$('backdrop').onchange=render;

$('fit').onclick=()=>{cancelAnimationFrame(renderRequest);processArtwork();fitVisibleArtwork();};
// Profiles opt in (luggage tags hang vertically; a wide logo may need to run along the tag).
$('rotate').hidden=!PROFILE.rotate;
$('rotate').onclick=()=>{rotation=(rotation+90)%360;cancelAnimationFrame(renderRequest);processArtwork();fitVisibleArtwork();};
$('overlayFit').onclick=()=>{$('fit').click();preview.focus();};

$('zoom').oninput=()=>setZoom(+$('zoom').value/100);
preview.addEventListener('wheel',e=>{
  if(!processed||loading||e.ctrlKey)return;
  e.preventDefault();
  const rect=preview.getBoundingClientRect(),delta=e.deltaY*(e.deltaMode===1?16:e.deltaMode===2?rect.height:1);
  const anchorX=(e.clientX-rect.left)*600/rect.width-(area.x+area.width/2);
  const anchorY=(e.clientY-rect.top)*stageHeight/rect.height+stageTop-(area.y+area.height/2);
  setZoom(scale*Math.exp(-Math.max(-300,Math.min(300,delta))*.002),anchorX,anchorY);
},{passive:false});
for(const button of document.querySelectorAll('.uv-pilot [data-view]'))button.onclick=()=>{view=button.dataset.view;for(const b of document.querySelectorAll('.uv-pilot [data-view]'))b.setAttribute('aria-pressed',String(b===button));render();};
let drag=null;
preview.onpointerdown=e=>{if(!processed)return;preview.focus();preview.setPointerCapture(e.pointerId);drag={id:e.pointerId,x:e.clientX,y:e.clientY,startX:x,startY:y};};
preview.onpointermove=e=>{if(!drag||e.pointerId!==drag.id)return;const r=preview.getBoundingClientRect();x=Math.max(-area.width,Math.min(area.width,drag.startX+(e.clientX-drag.x)*600/r.width));y=Math.max(-area.height,Math.min(area.height,drag.startY+(e.clientY-drag.y)*stageHeight/r.height));render();};
preview.onpointerup=preview.onpointercancel=()=>{drag=null;};
preview.onkeydown=e=>{if(!processed||!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key))return;e.preventDefault();const d=e.shiftKey?10:1;if(e.key==='ArrowLeft')x-=d;if(e.key==='ArrowRight')x+=d;if(e.key==='ArrowUp')y-=d;if(e.key==='ArrowDown')y+=d;render();};
const bytesOf = async c => new Uint8Array(await (await new Promise(r=>c.toBlob(r,'image/png'))).arrayBuffer());
function download(bytes,name,type){const url=URL.createObjectURL(new Blob([bytes],{type})),a=document.createElement('a');a.href=url;a.download=name;a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);}
function proofCanvas(){const c=surface(1200,stageHeight*2),currentView=view,currentBg=$('backdrop').value;view='product';$('backdrop').value='photo';paint(c.getContext('2d'),1200,stageHeight*2,false);view=currentView;$('backdrop').value=currentBg;return c;}
for(const [id,key,name]of[['downloadArt','color','review-color-rgb.png'],['downloadWhite','coverage','review-white-coverage.png']])$(id).onclick=async()=>{processArtwork();download(await bytesOf(renderLayers()[key]),name,'image/png');};
$('downloadProof').onclick=async()=>{processArtwork();download(await bytesOf(proofCanvas()),'review-visual-proof.png','image/png');};
async function packageEntries() {
  if(!maskReady)throw new Error('The product print area is still loading.');
  processArtwork();const layers=renderLayers(), originalHash=[...new Uint8Array(await crypto.subtle.digest('SHA-256',originalBytes))].map(b=>b.toString(16).padStart(2,'0')).join('');
  const ext=sourceFile.type==='image/jpeg'?'jpg':sourceFile.type==='image/webp'?'webp':'png';
  const manifest={...config,engineVersion:ENGINE_VERSION,createdAt:new Date().toISOString(),whiteMode:'under-artwork',
    file:{name:sourceFile.name,mime:sourceFile.type,bytes:sourceFile.size,sha256:originalHash,originalPath:'original/artwork.'+ext,...originalSize},
    backgroundRemoval:options(),placement:{x:x/area.width,y:y/area.height,scale,rotation,units:'print-region fractions; scale relative to contain fit at 90%; rotation in degrees clockwise, applied to the artwork before placement'},
    output:{width:layers.color.width,height:layers.color.height,dpi:null,colorSpace:'browser sRGB (not CMYK separation)',coverage:'0=none,255=full intent; partial alpha proportional, UNVALIDATED',files:{color:'review-color-rgb.png',white:'review-white-coverage.png',visual:'review-visual-proof.png'}},
    releaseBlockers:['Physical print dimensions and fixture approval','RIP white spot-channel/PDF preparation','Ink/media sample and partial-alpha policy','Commerce integration and order readback']};
  const enc=new TextEncoder();return [
    {name:'manifest.json',bytes:enc.encode(JSON.stringify(manifest,null,2))},
    {name:'README.txt',bytes:enc.encode('LOCAL REVIEW ONLY. NOT A PRINT-READY ROLAND JOB.\nThe color PNG is RGB and includes opaque white artwork. The grayscale coverage PNG encodes white intent: black=none, white=full. It is NOT a named RDG_WHITE spot plate. Physical dimensions, RIP separation and fixture must be approved.\nOriginal artwork is byte-preserved. No product photo or guide is in the artwork/coverage PNGs.\n')},
    {name:'original/artwork.'+ext,bytes:originalBytes},
    {name:'review-color-rgb.png',bytes:await bytesOf(layers.color)},
    {name:'review-white-coverage.png',bytes:await bytesOf(layers.coverage)},
    {name:'review-visual-proof.png',bytes:await bytesOf(proofCanvas())}
  ];
}
$('downloadPackage').onclick=async()=>{if(!original||loading)return;$('downloadPackage').disabled=true;try{download(zipStore(await packageEntries()),'uv-pilot-review.zip','application/zip');$('exportStatus').textContent='Review package created with unchanged original and separate output layers.';}catch(e){$('exportStatus').textContent='Could not create the package. Your design is still here.';}finally{controls();}};
  var TIERS = (CFG.hasTiers && CFG.tiers && CFG.tiers.length)
    ? CFG.tiers.filter(function (t) { return t && t.q > 0 && (t.pct > 0 || t.amt > 0); }).sort(function (a, b) { return a.q - b.q; })
    : [];
  var tiersBox = null, tiersApplying = false;
  function money(cents) { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: CFG.currency || 'USD' }); }
  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    return input && input.value;
  }
  function basePrice() {
    var vid = currentVariantId();
    var p = vid && CFG.variantPrices[vid];
    if (!p) { var k = Object.keys(CFG.variantPrices); p = k.length ? CFG.variantPrices[k[0]] : 0; }
    return +p || 0;
  }
  function currentQty() {
    var q = document.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 0;
    return isFinite(n) && n > 0 ? n : 0;
  }
  function tierFor(q) { var hit = null; for (var i = 0; i < TIERS.length; i++) { if (q >= TIERS[i].q) hit = TIERS[i]; } return hit; }
  function unitAt(tier) {
    var price = basePrice();
    if (!tier) return price;
    var u = tier.amt > 0 ? price - Math.round(tier.amt * 100)
          : tier.pct > 0 ? price - Math.floor(price * tier.pct / 100) : price;
    return (u > 0 && u <= price) ? u : price;
  }
  // A tier the minimum quantity already satisfies is not a discount anyone can
  // choose - it is simply the price. With min 25 and a 25/100/250... schedule the
  // 25+ price is the starting price, and every saving on the page is stated
  // against IT, not against a list price no order can pay. Regios still bills
  // list - pct at checkout; only what the shopper is told changes.
  function startTier() {
    var minQty = CFG.minQty || 1, hit = null;
    for (var i = 0; i < TIERS.length; i++) { if (TIERS[i].q <= minQty) hit = TIERS[i]; }
    return hit;
  }
  function startPrice() { var t = startTier(); return t ? unitAt(t) : basePrice(); }
  // Column headings are the quantity each price starts at; the last one carries the "+".
  function tierRowHTML() {
    var price = basePrice();
    var h = '<div class="cpd-ledger"><div class="cpd-ledger__lab" aria-hidden="true"><span>Qty</span><span>Each</span></div>'
      + '<div class="cpd-tiers__grid" data-tiers role="group" aria-label="Price each by quantity">'
      + '<button type="button" class="cpd-tier" data-tq="0" aria-pressed="false"><span class="cpd-tier__q" data-baserange></span>'
      + '<span class="cpd-tier__p">' + money(price) + '</span></button>';
    for (var i = 0; i < TIERS.length; i++) {
      h += '<button type="button" class="cpd-tier" data-tq="' + TIERS[i].q + '" aria-pressed="false"><span class="cpd-tier__q">'
        + TIERS[i].q.toLocaleString() + (i === TIERS.length - 1 ? '+' : '') + '</span>'
        + '<span class="cpd-tier__p">' + money(unitAt(TIERS[i])) + '</span></button>';
    }
    return h + '</div></div>';
  }
  // A click on a price sets the quantity to where that price starts, through the theme's
  // own input so Dawn, Regios and the overlay below all see an ordinary quantity change.
  function pickTier(e) {
    var cell = e.target.closest && e.target.closest('.cpd-tier');
    var qty = document.querySelector('input[name="quantity"]');
    if (!cell || !qty) return;
    var tq = +cell.getAttribute('data-tq');
    qty.value = Math.max(tq || 0, CFG.minQty || 1);
    qty.dispatchEvent(new Event('input', { bubbles: true }));
    qty.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function buildTiers() {
    if (!TIERS.length) { if (tiersBox) { tiersBox.remove(); tiersBox = null; } return; }
    if (!tiersBox) {
      tiersBox = document.createElement('div');
      tiersBox.className = 'cpd-tiers';
      tiersBox.setAttribute('data-cpd-tiers', '');
      tiersBox.addEventListener('click', pickTier);
      var totalWrap = document.querySelector('.total-price-wrapper');
      var priceBlock = CFG.domeMode ? document.querySelector('.product__info-container > .actual-price, .product__info-container > .price') : null;
      if (priceBlock && root.classList.contains('cpd--mounted')) priceBlock.parentNode.insertBefore(tiersBox, priceBlock.nextSibling);
      else if (totalWrap && root.classList.contains('cpd--mounted')) totalWrap.parentNode.insertBefore(tiersBox, totalWrap.nextSibling);
      else controlsPanel.insertBefore(tiersBox, controlsPanel.firstChild);
    }
    tiersBox.innerHTML = tierRowHTML();
  }
  function paintTiers() {
    if (!TIERS.length || !tiersBox) return;
    var q = currentQty(), minQty = CFG.minQty || 1, price = basePrice(), sp = startPrice();
    var hit = q > 0 ? tierFor(q) : null, active = hit ? hit.q : 0;
    var cells = tiersBox.querySelectorAll('.cpd-tier');
    for (var i = 0; i < cells.length; i++) {
      var isOn = +cells[i].getAttribute('data-tq') === active;
      cells[i].classList.toggle('cpd-tier--on', isOn);
      if (cells[i].getAttribute('aria-pressed') !== String(isOn)) cells[i].setAttribute('aria-pressed', String(isOn));
    }
    // Bands the minimum has swallowed are hidden rather than quoted as a price nobody can pay.
    var baseCell = tiersBox.querySelector('[data-tq="0"]');
    if (baseCell) baseCell.style.display = TIERS[0].q <= minQty ? 'none' : '';
    for (var j = 0; j < TIERS.length; j++) {
      var cell = tiersBox.querySelector('[data-tq="' + TIERS[j].q + '"]');
      if (cell) cell.style.display = (j + 1 < TIERS.length && TIERS[j + 1].q <= minQty) ? 'none' : '';
    }
    var br = tiersBox.querySelector('[data-baserange]');
    if (br) {
      var brText = minQty.toLocaleString();
      if (br.textContent !== brText) br.textContent = brText;
    }
    // Overlay the tiered unit price and total on the theme's own price blocks.
    var unit = hit ? unitAt(hit) : price;
    tiersApplying = true;
    try {
      var pp = document.querySelector('.product-price');
      if (pp && q > 0) {
        var t = money(unit);
        if (pp.textContent.trim() !== t + 'ea' || !pp.querySelector('.price-ea')) pp.innerHTML = t + '<span class="price-ea">ea</span>';
      }
      // The saving beside the price: one shared writer (custom-product-pricing.js) for every page.
      if (pp && q > 0 && window.SPID && SPID.paintPriceSave) SPID.paintPriceSave(unit / 100, sp / 100);
      var tp = document.querySelector('.total-price-wrapper .total-price');
      if (tp && q > 0) { var tt = money(unit * q); if (tp.textContent.trim() !== tt) tp.textContent = tt; }
    } finally { tiersApplying = false; }
  }
  // Live self-correct: if the Regios config is on the page, the shared resolver in
  // custom-product.js reads the exact breaks the app prices checkout from. Only a
  // well-formed, strictly increasing schedule is allowed to replace the snapshot.
  function liveTiers() {
    var api = window.SPID_VolumeTiers;
    if (!api || !api.breaksFor) return null;
    var breaks = null;
    try { breaks = api.breaksFor({ tags: CFG.tags, productId: CFG.productId, variantId: currentVariantId(), collectionIds: [] }, true); } catch (e) { return null; }
    if (!breaks || !breaks.length) return null;
    var out = [], fixed = null;
    for (var i = 0; i < breaks.length; i++) {
      var d = breaks[i].discount || {}, q = parseFloat(breaks[i].minimumQuantity);
      var isFixed = d.type === 'FIXED_AMOUNT', v = parseFloat(isFixed ? d.amount : d.percentage);
      if (!isFinite(q) || !isFinite(v) || q <= 0 || v <= 0) return null;
      if (fixed === null) fixed = isFixed; else if (fixed !== isFixed) return null; // one kind per ladder
      out.push(isFixed ? { q: q, amt: v } : { q: q, pct: v });
    }
    out.sort(function (a, b) { return a.q - b.q; });
    var key = fixed ? 'amt' : 'pct';
    for (var k = 1; k < out.length; k++) { if (out[k].q <= out[k - 1].q || out[k][key] <= out[k - 1][key]) return null; }
    return out;
  }
  function reconcileTiers() {
    var live = liveTiers();
    if (!live) return;
    if (JSON.stringify(live) === JSON.stringify(TIERS)) return;
    TIERS = live; buildTiers(); paintTiers();
  }
  function initTiers() {
    if (!TIERS.length) return;
    // custom-product-pricing.js writes the price and total on every quantity change; this
    // lets it write the tier price itself instead of the base price this row then corrects.
    window.SPID = window.SPID || {};
    SPID.tierUnit = function (q) { return TIERS.length ? unitAt(tierFor(q)) / 100 : 0; };
    buildTiers(); paintTiers();
    document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') setTimeout(paintTiers, 0); });
    document.addEventListener('change', function (e) { if (e.target && (e.target.name === 'quantity' || e.target.name === 'id')) { setTimeout(paintTiers, 60); setTimeout(paintTiers, 650); } });
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('quantity-input button, .quantity__button')) { setTimeout(paintTiers, 0); setTimeout(paintTiers, 120); } });
    // Watch the whole buy box: Dawn's variant change swaps price nodes wholesale, so an
    // observer pinned to one node would die with it. Observer callbacks are delivered
    // asynchronously, after tiersApplying has already been reset, so that flag alone
    // cannot stop a repaint from re-triggering itself. Ignore records that originate
    // inside our own tiers box, and only ever write to the DOM when the value changed.
    var watch = document.querySelector('.product__info-container, .product__info-wrapper') || document.querySelector('.total-price-wrapper');
    if (watch && window.MutationObserver) {
      new MutationObserver(function (records) {
        if (tiersApplying) return;
        for (var r = 0; r < records.length; r++) {
          if (tiersBox && tiersBox.contains(records[r].target)) continue;
          setTimeout(paintTiers, 0);
          return;
        }
      }).observe(watch, { childList: true, subtree: true, characterData: true });
    }
    [800, 2500, 5000].forEach(function (ms) { setTimeout(reconcileTiers, ms); });
  }


// UV uses the existing Shopify product form; files become hosted line-item properties.
const form=document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]');
let preparing=false,ready=false;
function orderInput(name,type='hidden'){const el=document.createElement('input');el.name='properties['+name+']';el.type=type;if(type==='file'){el.hidden=true;el.tabIndex=-1;}form.appendChild(el);return el;}
function attachFile(el,bytes,name,type){const transfer=new DataTransfer();transfer.items.add(new File([bytes],name,{type}));el.files=transfer.files;if(el.files.length!==1)throw new Error('Attachment failed');el.disabled=false;}
function orderError(message){$('order-error').textContent=message;$('order-error').hidden=!message;}
function showDesign(){document.querySelector('.uv-pilot .stage').hidden=false;$('photo').hidden=true;updateEditHint();document.querySelectorAll('.uv-thumbs button').forEach(b=>b.setAttribute('aria-pressed',String(b.hasAttribute('data-uv-design'))));}
document.querySelectorAll('.uv-thumbs button').forEach(button=>button.addEventListener('click',()=>{if(button.hasAttribute('data-uv-design'))return showDesign();$('photo').src=button.dataset.uvPhoto;$('photo').alt=button.getAttribute('aria-label');$('photo').hidden=false;updateEditHint();document.querySelector('.uv-pilot .stage').hidden=true;document.querySelectorAll('.uv-thumbs button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));
$('skip').addEventListener('change',()=>{orderError('');updateEditHint();});
if(form){
 const originalInput=orderInput('_Artwork','file'),colorInput=orderInput('_Proof','file'),whiteInput=orderInput('_WhiteCoverage','file'),previewInput=orderInput('_Preview','file'),designInput=orderInput('_Design'),artworkInput=orderInput('Artwork'),methodInput=orderInput('_PrintMethod');
 const attachments=[originalInput,colorInput,whiteInput,previewInput];attachments.forEach(i=>i.disabled=true);methodInput.value='UV printing';
 function signature(){return JSON.stringify({variant:config.variantId,file:sourceFile?.name,bytes:sourceFile?.size,x,y,scale,rotation,options:options(),skip:$('skip').checked});}
 form.addEventListener('submit',async event=>{
  if(ready){ready=false;return;}
  if($('skip').checked){attachments.forEach(i=>i.disabled=true);designInput.value=JSON.stringify({...config,artworkPending:true,requiresArtReview:true});artworkInput.disabled=false;artworkInput.value='Sending logo after checkout';orderError('');return;}
  event.preventDefault();event.stopImmediatePropagation();if(preparing)return;
  if(!original||!sourceFile||loading){orderError('Upload your logo or choose Skip the designer before adding to cart.');$('upload').focus();return;}
  if(!maskReady){orderError('The product print area is still loading. Please try again.');return;}
  preparing=true;orderError('Preparing your artwork…');const before=signature(),file=sourceFile,submitter=event.submitter;const button=form.querySelector('[type="submit"]');if(button)button.disabled=true;
  try{
   cancelAnimationFrame(renderRequest);processArtwork();const layers=renderLayers();
   const [colorBytes,whiteBytes,previewBytes]=await Promise.all([bytesOf(layers.color),bytesOf(layers.coverage),bytesOf(proofCanvas())]);
   if(before!==signature()||loading||file!==sourceFile)throw new Error('Your design changed. Please add it to cart again.');
   attachFile(originalInput,originalBytes,sourceFile.name,sourceFile.type);attachFile(colorInput,colorBytes,'uv-color-artwork.png','image/png');attachFile(whiteInput,whiteBytes,'uv-white-coverage.png','image/png');attachFile(previewInput,previewBytes,'uv-product-preview.png','image/png');
   designInput.value=JSON.stringify({...config,engineVersion:ENGINE_VERSION,requiresArtReview:true,original:originalSize,whiteMode:'under-artwork',backgroundRemoval:options(),placement:{x:x/area.width,y:y/area.height,scale,rotation},output:{width:layers.color.width,height:layers.color.height,dpi:null,whiteCoverage:'grayscale intent, not RIP spot plate'}});
   artworkInput.value='';artworkInput.disabled=true;orderError('');ready=true;if(button)button.disabled=false;form.requestSubmit(submitter||button);
  }catch(error){attachments.forEach(i=>i.disabled=true);orderError(error.message==='Your design changed. Please add it to cart again.'?error.message:'We could not attach your artwork. Try again, or choose Skip the designer to send it after checkout.');}
  finally{preparing=false;if(button)button.disabled=false;}
 },true);
}
// Match the dome template's compact quantity/total and supporting CTA row.
const qtyBlock=info?.querySelector('.product-form__quantity'),totalBlock=info?.querySelector('.total-price-wrapper');
if(qtyBlock&&totalBlock){const row=document.createElement('div');row.className='cpd-qtyrow';qtyBlock.before(row);row.append(qtyBlock,totalBlock);}
if(info){const blankLink=info.querySelector('[data-reel-counterpart]');if(blankLink)blankLink.textContent=PROFILE.blankLabel||(PROFILE.shape==='oval'?'Order blank reels (no logo)':'Order blank holders (no logo)');const quote=info.querySelector('[id^="quote-btn-"]');if(quote)quote.textContent='Request a Quote';}

syncRenderVariant();initTiers();controls();render();
// Local test page uses the same implementation through ordinary UI and its own canvas tests.

})();
